export class CassError {
	errorMessage?: string;
	errorMessageKey?: string;
	errorInterpolateParams?: any;
	isUnexpected: boolean = false;
	isDiscountApplicationError = false;

	httpStatus: number = -1;
	errorCode: number = -1;

	static createErrorWithMessageKey(errorMessageKey: string, errorInterpolateParams?: any): CassError {
		const er = new CassError();
		er.errorMessageKey = errorMessageKey;
		er.errorInterpolateParams = errorInterpolateParams;
		return er;
	}

	static createErrorWithText(errorMessage: string): CassError {
		const er = new CassError();
		er.errorMessage = errorMessage;
		return er;
	}

	static createErrorWithCode(httpStatus: number, errorCode: number, errorMessage: string): CassError {
		const er = new CassError();
		er.httpStatus = httpStatus;
		er.errorCode = errorCode;
		er.errorMessage = errorMessage;
		return er;
	}
}


